import { CdkStepper } from '@angular/cdk/stepper';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'gh-hero-stepper',
    templateUrl: 'hero-stepper.component.html',
    providers: [{ provide: CdkStepper, useExisting: HeroStepperComponent }],
    standalone: false
})
export class HeroStepperComponent extends CdkStepper implements OnInit {

  ngOnInit() {
    setTimeout(() => this.autoplay(), 5000);
  }

  selectStepByIndex(index: number): void {
    this.selectedIndex = index;
  }

  private autoplay() {
    if (this.selectedIndex < 2) {
      this.next();
    } else {
      this.selectedIndex = 0;
    }
    setTimeout(() => this.autoplay(), 4000);
  }
}
